import React from "react";
import {Typography} from "@material-ui/core";

export default function Subtitle(props: { title: string }) {
    return (
        <Typography
            variant={"subtitle2"}
            style={{
                marginBottom: 4,
                marginRight: 10,
                marginTop: 8,
                fontWeight: "bolder",
                color: "gray"
            }}
        >
            {props.title}
        </Typography>
    );
}
